import { Routes, Route } from "react-router-dom"
import { GuestLayout } from "./components/GuestLayout"
import { AuthLayout } from "./components/AuthLayout"
import { Login } from "./pages/Login"
import { PasswordDimenticata } from "./pages/PasswordDimenticata"
import { ResetPassword } from "./pages/ResetPassword"
import { AttivazioneAccount } from "./pages/AttivazioneAccount"
import { MagikUI } from "@inmagik/magik-ui"
import UtenteCreate from "./pages/Utenti/UtenteCreate"
import UtenteUpdate from "./pages/Utenti/UtenteUpdate"
import Utenti from "./pages/Utenti/Utenti"
import Profilo from "./pages/Profilo/Profilo"
import { Home } from "./pages/Home"
import Collections from "./pages/Collections/Collections"
import CollectionCreate from "./pages/Collections/CollectionCreate"
import CollectionUpdate from "./pages/Collections/CollectionUpdate"
import NamedEntities from "./pages/NamedEntities/NamedEntities"
import NamedEntityCreate from "./pages/NamedEntities/NamedEntityCreate"
import NamedEntityUpdate from "./pages/NamedEntities/NamedEntityUpdate"
import Genres from "./pages/Genres/Genres"
import GenreCreate from "./pages/Genres/GenreCreate"
import GenreUpdate from "./pages/Genres/GenreUpdate"
import Documents from "./pages/Documents/Documents"
import DocumentCreate from "./pages/Documents/DocumentCreate"
import DocumentUpdate from "./pages/Documents/DocumentUpdate"
import Texts from "./pages/Texts/Texts"
import TextCreate from "./pages/Texts/TextCreate"
import TextUpdate from "./pages/Texts/TextUpdate"
import Stories from "./pages/Stories/Stories"
import StoryCreate from "./pages/Stories/StoryCreate"
import StoryUpdate from "./pages/Stories/StoryUpdate"
import Media from "./pages/Media/Media"
import MediaCreate from "./pages/Media/MediaCreate"
import MediaUpdate from "./pages/Media/MediaUpdate"
import GroupsOfResearches from "./pages/GroupOfResearches/GroupOfResearches"
import GroupOfResearchUpdate from "./pages/GroupOfResearches/GroupOfResearchUpdate"
import GroupOfResearchCreate from "./pages/GroupOfResearches/GroupOfResearchCreate"
import Outputs from "./pages/Outputs/Outputs"
import OutputCreate from "./pages/Outputs/OuputCreate"
import OutputUpdate from "./pages/Outputs/OutputUpdate"

export function Navigation() {
  return (
    <MagikUI>
      <Routes>
        <Route path="/" element={<AuthLayout redirect_to="/login" />}>
          <Route index element={<Home />}></Route>
          <Route path="/utenti/utenti" element={<Utenti />}></Route>
          <Route path="/utenti/utenti/new" element={<UtenteCreate />}></Route>
          <Route path="/utenti/utenti/:id" element={<UtenteUpdate />}></Route>
          <Route path="/collections/collections" element={<Collections />}></Route>
          <Route path="/collections/collections/new" element={<CollectionCreate />}></Route>
          <Route path="/collections/collections/:id" element={<CollectionUpdate />}></Route>
          <Route path="/named-entities/named-entities" element={<NamedEntities />}></Route>
          <Route path="/named-entities/named-entities/new" element={<NamedEntityCreate />}></Route>
          <Route path="/named-entities/named-entities/:id" element={<NamedEntityUpdate />}></Route>
          <Route path="/genres/genres" element={<Genres />}></Route>
          <Route path="/genres/genres/new" element={<GenreCreate />}></Route>
          <Route path="/genres/genres/:id" element={<GenreUpdate />}></Route>
          <Route path="/documents/documents" element={<Documents />}></Route>
          <Route path="/documents/documents/new" element={<DocumentCreate />}></Route>
          <Route path="/documents/documents/:id/*" element={<DocumentUpdate />}></Route>
          <Route path="/text-contents/text-contents" element={<Texts />}></Route>
          <Route path="/text-contents/text-contents/new" element={<TextCreate />}></Route>
          <Route path="/text-contents/text-contents/:id" element={<TextUpdate />}></Route>
          <Route path="/stories/stories" element={<Stories />}></Route>
          <Route path="/stories/stories/new" element={<StoryCreate />}></Route>
          <Route path="/stories/stories/:id/*" element={<StoryUpdate />}></Route>
          <Route path="/media/media" element={<Media />}></Route>
          <Route path="/media/media/new" element={<MediaCreate />}></Route>
          <Route path="/media/media/:id" element={<MediaUpdate />}></Route>
          <Route path="/group-of-researches/group-of-researches" element={<GroupsOfResearches />}></Route>
          <Route path="/group-of-researches/group-of-researches/new" element={<GroupOfResearchCreate />}></Route>
          <Route path="/group-of-researches/group-of-researches/:id" element={<GroupOfResearchUpdate />}></Route>
          <Route path="/outputs/outputs" element={<Outputs />}></Route>
          <Route path="/outputs/outputs/new" element={<OutputCreate />}></Route>
          <Route path="/outputs/outputs/:id" element={<OutputUpdate />}></Route>
          <Route path="/profilo" element={<Profilo />}></Route>
        </Route>
        <Route path="/login" element={<GuestLayout redirect_to="/" />}>
          <Route index element={<Login />}></Route>
        </Route>
        <Route path="/password-dimenticata" element={<GuestLayout redirect_to="/" />}>
          <Route index element={<PasswordDimenticata />}></Route>
        </Route>
        <Route path="/reset-password" element={<GuestLayout redirect_to="/" />}>
          <Route index element={<ResetPassword />}></Route>
        </Route>
        <Route path="/attivazione-account" element={<GuestLayout redirect_to="/" />}>
          <Route index element={<AttivazioneAccount />}></Route>
        </Route>
      </Routes>
    </MagikUI>
  )
}
